// extracted by mini-css-extract-plugin
export default {"pageWrapper":"TransporterGuide_pageWrapper__Pp3i3","sectionsContainer":"TransporterGuide_sectionsContainer__qu2H9","scrollTarget":"TransporterGuide_scrollTarget__5eNVy"};